const title = {
  orders: 'Orders',
  statement: 'Overview',
  basket: 'Shopping Cart',
  ordered: 'Ordered products',
  spendTime: 'Spend over time',
  credit: 'Credit',
  receipting: 'Goods receipting',
  invoices: 'Invoices & Credit Notes',
  creditnotes: 'Credit Requests',
  resolvednotes: 'Credit Requests',
  'product-issues': 'Product Issues',
  'gross-profit': 'Gross Profit',
}

const getTitle = slug => title[slug]

export default getTitle
